<div class="demo-du-range-bar-container" #container>
  <div class="demo-du-range-bar-wrapper">
    <span class="demo-du-range-bar-label">
      {{ this.label ? this.label : 'No of Patients' }}:
    </span>

    <span class="demo-du-range-bar-min">
      &gt; {{ min || 0 }}
    </span>

    <svg #barSvg class="demo-du-range-bar-svg"></svg>

    <span class="demo-du-range-bar-max">
      &lt; {{ max || 0 }}
    </span>
  </div>

  <!-- Tooltip overlay -->
  <svg #tooltipSvg class="demo-du-range-bar-tooltip-svg"></svg>
</div>
